import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import moment, { Moment } from 'moment';
import Order from 'src/smoothr-web-app-core/models/Order';
import Slot from 'src/smoothr-web-app-core/models/Slot';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import { TimeUtils } from 'src/smoothr-web-app-core/utils/time-utils';
import { getSlotsByOrder, isVenueOpen, sleep } from 'src/smoothr-web-app-core/utils/utils';

export enum SelectionTimeType {
	ASAP = 'asap',
	LATER = 'later',
}

@Component({
	selector: 'app-select-time-slot-dialog',
	templateUrl: './select-time-slot-dialog.component.html',
	styleUrls: ['./select-time-slot-dialog.component.scss'],
})
export class SelectTimeSlotDialogComponent implements OnInit {
	public order: Order;
	public venue: Venue;
	public selectionTimeTypeEnum = SelectionTimeType;
	public selectedTimeType: SelectionTimeType = SelectionTimeType.LATER;
	public slots: Moment[] = [];
	public dates: Moment[] = [];
	public maxDates = 7;
	public slot: Moment;
	public TimeUtils = TimeUtils;
	public now: moment.Moment;
	public showDates: boolean = false;
	public showTime: boolean = false;
	public timeSelected: Moment;
	public loading = false;
	public isAsapAvailable = false;
	constructor(
		private modalCtrl: ModalController,
		public translate: TranslateService
	) {}
	static async show(modalCtrl: ModalController, order: Order, venue: Venue): Promise<{ asap: boolean; slot: Moment }> {
		const modal = await modalCtrl.create({
			component: SelectTimeSlotDialogComponent,
			cssClass: ['auto-height', 'time-dialog'],
			componentProps: {
				venue,
				order,
			},
			showBackdrop: true,
		});
		await modal.present();
		await sleep(100);
		const result = (await modal.onDidDismiss()).data;
		return result;
	}
	ngOnInit() {
		this.checkIfAsapExist();
		this.loadSlots();
	}
	private checkIfAsapExist() {
		const isVenueOpenValue = isVenueOpen(this.venue);
		if (isVenueOpenValue) {
			this.isAsapAvailable = true;
		}
	}
	public dismiss() {
		this.modalCtrl.dismiss();
	}
	public selectedType(type: SelectionTimeType) {
		this.selectedTimeType = type;
	}
	public asap() {
		return moment().format('HH:mm');
	}
	public async loadSlots() {
		console.log(this.venue, this.order);
		this.slots = [];
		this.loading = false;
		if (!this.venue) {
			this.loading = true;
			return;
		}
		try {
			const slots = (await getSlotsByOrder(this.venue, this.order)).map(slot => moment(slot.time));
			if (slots.length === 0) {
				this.loading = true;

				return;
			}
			this.slots = slots;
			this.slots.forEach((slot, index) => {
				if (index === 0) {
					this.slot = slot;
					this.timeSelected = slot;
				}
				const insertedDate = this.dates.find(date => TimeUtils.isSameDate(date, slot));
				if (!insertedDate) {
					this.dates.push(slot);
				}
			});
			this.loading = true;
		} catch (e) {
			this.slots = [];
			this.loading = true;
		}
	}
	public async setDate(date: Moment) {
		this.slot = date;
		await sleep(100);
		this.showDates = false;
	}
	slotToDateText(slot: Moment): string {
		if (TimeUtils.isSameDate(slot, this.now)) {
			return this.translate.instant('today');
		}
		return slot.format('dd DD.MM.');
	}
	showDateFun() {
		this.showDates = !this.showDates;
	}
	setTime(time: Moment) {
		this.slot = time;
		this.timeSelected = time;
		this.showTime = false;
	}
	public timesForDate(selectedDate: Moment): Moment[] {
		const date = selectedDate ?? this.dates[0] ?? null;
		if (!date) {
			return [];
		}
		return this.slots.filter(slot => TimeUtils.isSameDate(slot, date) || (!slot && date === this.dates[0]));
	}
	slotToTimeText(slot: Moment): string {
		if (!slot) return this.translate.instant('checkout_modal.first_slot');
		return slot.format('HH:mm');
	}
	public showTimeFun() {
		this.showTime = !this.showTime;
	}
	public showDisable() {
		if (this.selectedTimeType === this.selectionTimeTypeEnum.ASAP) {
			return false;
		}
		return !this.timeSelected;
	}
	dayShow() {
		return moment().isSame(this.slot, 'day') ? 'Today' : moment(this.slot).format('dddd');
	}
	dayTime() {
		return this.slot ? moment(this.slot).format('HH:mm') : '';
	}
	closeTime() {
		console.log(this.selectedTimeType);
		if (this.selectedTimeType === SelectionTimeType.ASAP) {
			this.modalCtrl.dismiss({
				asap: true,
			});
		} else {
			console.log(this.slot);
			this.modalCtrl.dismiss({
				slot: this.slot,
			});
		}
	}
}
